"use client";
import JumpLink from "@/components/JumpLink";
import style from "../style.module.scss";
import { imageUtil } from "@/lib/jdiClientUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper as SwiperCore } from "swiper/types";
import { useRef } from "react";
import Prev from "@/assets/icons/prev.svg";
import Next from "@/assets/icons/next.svg";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25223";
import CDNImage from "@/components/cdnImage/cdnImage";

export default function Banner({ PageConfig }: any) {
  const swiperRef = useRef<SwiperCore>();
  const handleClick = (index: number) => {
    sendClickTrack.Home_Banner({ index: index });
  };

  const onlyKey = (url: string) => {
    return imageUtil.getImgDetailsFromAbsoluteImg(url)?.imgKey;
  };

  const hasEnoughSlides = PageConfig.data.length >= 3;
  const slide = (carousel: any, index: number) => {
    return (
      <div
        className={style.slideItem}
        exptag={"exp|" + EXPOSURE_RECORD.Home_Banner_Expo}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({ index: index })}
      >
        <CDNImage src={onlyKey(carousel?.image?.imageUrl)} width={1264} height={280} alt="Big Promotion banner" priority={index === 0} />
      </div>
    );
  };
  return (
    <Swiper
      slidesPerView={1}
      loop={hasEnoughSlides}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper;
      }}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      modules={[Pagination, Autoplay]}
      className={style.mySwiper}
    >
      {PageConfig.data.map((carousel: any, index: any) => (
        <SwiperSlide key={index} onClick={() => handleClick(index)}>
          {carousel.jump ? <JumpLink jumpParams={carousel?.jump}>{slide(carousel, index)}</JumpLink> : <>{slide(carousel, index)}</>}
        </SwiperSlide>
      ))}
      {PageConfig.data.length > 1 && (
        <div className={style.buttonGroup}>
          <button className={style.prev} onClick={() => swiperRef.current?.slidePrev()}>
            <Prev />
          </button>
          <button className={style.next} onClick={() => swiperRef.current?.slideNext()}>
            <Next />
          </button>
        </div>
      )}
    </Swiper>
  );
}
